export const playVideo = ($this) => {
  $this.hide();
  $this.siblings("video").get(0).play();
  $this.siblings("video").attr("controls", "controls");
};
